export const buttonNames = {
  BACK_BUTTON: 'back-button',
  NEXT_BUTTON: 'next-button',
  APPLY_BUTTON: 'apply-button',
  CANCEL_BUTTON: 'cancel-button',
};

export default { buttonNames };
